import { render, staticRenderFns } from "./pixelModal.vue?vue&type=template&id=7f782883&scoped=true&"
import script from "./pixelModal.vue?vue&type=script&lang=js&"
export * from "./pixelModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f782883",
  null
  
)

export default component.exports